import script from "./Get-Started-Step6.vue?vue&type=script&setup=true&lang=js"
export * from "./Get-Started-Step6.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__